__turbopack_context__.v({
  "about": "_8zaB4W_about",
  "bullets": "_8zaB4W_bullets",
  "container": "_8zaB4W_container",
  "content": "_8zaB4W_content",
  "heading": "_8zaB4W_heading",
});
